module.exports = __webpack_public_path__ + "img/fxh-cp.68019f64.jpg";